import type { AssessmentMode } from '../types.js';

interface ModeChooserProps {
  onChoose: (mode: AssessmentMode) => void;
}

const MODES: Array<{ value: AssessmentMode; title: string; desc: string; cta: string }> = [
  {
    value: 'evaluate',
    title: 'Evaluate an AI use case',
    desc: 'You have a specific problem or task in mind. Find out whether AI can solve it, how, and what it would take.',
    cta: 'I have a problem to check →',
  },
  {
    value: 'discover',
    title: 'Discover AI use cases',
    desc: "You want to adopt AI but aren't sure where to start. We'll scope your organisation and pinpoint the highest-value opportunity.",
    cta: 'Help me find where AI fits →',
  },
];

export function ModeChooser({ onChoose }: ModeChooserProps): React.JSX.Element {
  return (
    <div>
      <p className="tbo-lead">
        Two ways to start. Pick the one that fits where you are with AI.
      </p>
      <div className="tbo-modes">
        {MODES.map((m) => (
          <button
            key={m.value}
            type="button"
            className="tbo-mode-card"
            onClick={() => onChoose(m.value)}
          >
            <span className="tbo-mode-title">{m.title}</span>
            <span className="tbo-mode-desc">{m.desc}</span>
            <span className="tbo-mode-cta">{m.cta}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
